const parseJSON = (toParse: string) => {
  try {
    return JSON.parse(toParse);
  } catch {
    return '';
  }
};

export default parseJSON;
